function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "u",
  d: "M53.26,117.42a36.64,36.64,0,0,0,14.52-2.73A30.6,30.6,0,0,0,78.61,107a33.61,33.61,0,0,0,6.76-11.78,46.61,46.61,0,0,0,2.32-15.07V.61h17.63V80.16a59.63,59.63,0,0,1-3.61,21,48.71,48.71,0,0,1-10.32,16.76A47,47,0,0,1,75,129a56.22,56.22,0,0,1-21.74,4,56.17,56.17,0,0,1-21.73-4,47.4,47.4,0,0,1-16.44-11.09A48.37,48.37,0,0,1,4.72,101.17a59.63,59.63,0,0,1-3.61-21V.61H18.74V80.07a46.66,46.66,0,0,0,2.33,15.07,33.39,33.39,0,0,0,6.76,11.78,30.78,30.78,0,0,0,10.87,7.72A36.25,36.25,0,0,0,53.26,117.42Z",
  transform: "translate(-1.11 -0.61)",
  fill: "#ffb633"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "dot",
  d: "M123.31,121.44a11.56,11.56,0,0,1,.87-4.47,11.36,11.36,0,0,1,2.38-3.65,11.38,11.38,0,0,1,12.55-2.47,11.75,11.75,0,0,1,3.66,2.47,11.14,11.14,0,0,1,2.42,3.65,12.18,12.18,0,0,1,0,9,11.29,11.29,0,0,1-2.42,3.61,11,11,0,0,1-3.66,2.42,11.94,11.94,0,0,1-9,0,10.34,10.34,0,0,1-3.6-2.42,11.44,11.44,0,0,1-3.25-8.13Z",
  transform: "translate(-1.11 -0.61)",
  fill: "#ffb633"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 144.94 132.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.03c75fd7.svg";
export { ForwardRef as ReactComponent };